export default __webpack_public_path__ + "static/media/DK-Logo-2020-blue.e1dfbe37.svg";